var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import { messagesAPI } from "../../API/api";
import { makeChatId } from "../../utils/utils";
import { setMessages } from "./messagesSlice";
export const setChat = createAsyncThunk('app/getChatId', (users, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (users === null)
        return null;
    if ((_a = users.guestInfo) === null || _a === void 0 ? void 0 : _a.chatID)
        return users.guestInfo;
    const getID = makeChatId(users);
    const id = yield messagesAPI.getChatID(getID);
    console.log(id);
    if (!getID)
        return rejectWithValue(users);
    return (Object.assign(Object.assign({}, users.guestInfo), { chatID: getID }));
}));
export const outChat = createAsyncThunk('app/OutChat', (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    yield dispatch(setChat(null)).unwrap();
    dispatch(setMessages(null));
    return { cleared: true };
}));
